export const COMMON_SHEET_MAP = {
  'Converter Technology': 0,
  'AC Voltages': 1,
  Computers: 2,
};

export const CLF_BASIC_SHEET_MAP = {
  'Valve Deblock': 0,
  'AC Nom Volt RMS': 1,
  Computers: 2,
  'AC Breakers': 3,
  'AC Voltages': 4,
};

export const CLF_COMMUTATION_SHEET_MAP = {
  'AC Trafo Currents': 0,
  'Commutation Failure Indicator': 1,
  'AC Voltages': 2,
  Computers: 3,
  Alpha: 4,
};

export const commonFields = [
  { key: 'Converter Technology', configKey: 'converter_technology', required: true },
  { key: 'AC Voltages', configKey: 'ac_voltages', isArray: true, required: true },
  { key: 'Computers', configKey: 'computers', isArray: true, required: true },
];

export const clfBasicFields = [
  { key: 'Valve Deblock', configKey: 'valve_deblock', required: true },
  { key: 'AC Nom Volt RMS', configKey: 'ac_nom_volt_rms', isNumber: true, required: true },
  { key: 'AC Breakers', configKey: 'ac_breakers', isArray: true, required: true },
  { key: 'Computers', configKey: 'computers', isArray: true },
  { key: 'AC Voltages', configKey: 'ac_voltages', isArray: true },
];

export const clfCommutationFields = [
  { key: 'AC Trafo Currents', configKey: 'ac_trafo_currents', isArray: true, required: true },
  { key: 'Alpha', configKey: 'alpha', required: true },
  {
    key: 'Commutation Failure Indicator',
    configKey: 'commutation_failure_indicator',
    required: true,
  },
  { key: 'Computers', configKey: 'computers', isArray: true },
  { key: 'AC Voltages', configKey: 'ac_voltages', isArray: true },
];

export const COMMON_WORKSHEET_COLUMNS = [
  { header: 'Converter Technology *', key: 'converter_technology', width: 25, type: 'string' },
  { header: 'AC Voltages **', key: 'ac_voltages', width: 20, type: 'string' },
  { header: 'Computers **', key: 'computers', width: 20, type: 'string' },
];

export const CLF_BASIC_WORKSHEET_COLUMNS = [
  { header: 'Valve Deblock *', key: 'valve_deblock', width: 25, type: 'string' },
  { header: 'AC Nom Volt RMS *', key: 'ac_nom_volt_rms', width: 20, type: 'number' },
  { header: 'Computers **', key: 'computers', width: 20, type: 'string' },
  { header: 'AC Breakers *', key: 'ac_breakers', width: 20, type: 'string' },
  { header: 'AC Voltages **', key: 'ac_voltages', width: 20, type: 'string' },
];

export const CLF_COMMUTATION_WORKSHEET_COLUMNS = [
  { header: 'AC Trafo Currents *', key: 'ac_trafo_currents', width: 25, type: 'string' },
  {
    header: 'Commutation Failure Indicator *',
    key: 'commutation_failure_indicator',
    width: 30,
    type: 'string',
  },
  { header: 'AC Voltages **', key: 'ac_voltages', width: 20, type: 'string' },
  { header: 'Computers **', key: 'computers', width: 20, type: 'string' },
  { header: 'Alpha *', key: 'alpha', width: 20, type: 'string' },
];

export const WORKSHEET_PROTECTION_OPTIONS = {
  selectLockedCells: true,
  selectUnlockedCells: true,
  formatCells: true,
  formatColumns: false,
  formatRows: false,
  insertColumns: false,
  insertRows: true,
  deleteColumns: false,
  deleteRows: true,
  sort: true,
  autoFilter: true,
};

export const INFO_ROW_TEXT =
  'Note: The two first rows are locked and fields marked as required (*) need at least one value for the algorithm to run. Fields marked with (**) can be specified in the common section or overwritten for specific algorithm.';

export const EMPTY_ROWS_COUNT = 500;

export const PARSED_CONFIG_TEMPLATE = {
  common: {
    converter_technology: '',
    computers: [],
    ac_voltages: [],
  },
  clf_basic: {
    ac_breakers: [],
    valve_deblock: '',
    ac_nom_volt_rms: null,
    computers: [],
    ac_voltages: [],
  },
  clf_commutation: {
    ac_trafo_currents: [],
    commutation_failure_indicator: '',
    alpha: '',
    computers: [],
    ac_voltages: [],
  },
};
